import { ComponentLoader } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

const LoaderWithText = ({
  title,
  cellStyles,
  titleStyle,
  children,
  size,
  containerStyles
}) => {
  const { t } = useTranslation();
  return (
    <ComponentLoader
      className={cx(containerStyles)}
      contentClassName={cx(
        cellStyles,
        'col-12',
        'col-md-4',
        'm-auto',
        'position-relative'
      )}
      size={size}
    >
      {title && (
        <span className={cx(titleStyle, 'u-color--DarkGray', 'u-fs--16')}>
          {t(title)}
        </span>
      )}
      {!!children && children}
    </ComponentLoader>
  );
};

LoaderWithText.propTypes = {
  title: PropTypes.string,
  size: PropTypes.string,
  cellStyles: PropTypes.string,
  titleStyle: PropTypes.string,
  children: PropTypes.node,
  containerStyles: PropTypes.string
};

export default LoaderWithText;
